export let mapStyle;